import { VisitMedicalImagingCreateCommand, VisitMedicalImagingQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { VisitMedicalImgaingCreateParameters } from './AddMedicalImagingLink.types';

type VisitImagingCreateActionOptions = {
   visitId: number;
};

export const useVisitMedicalImagingCreateCommand = (
   options: VisitImagingCreateActionOptions
): UseCqrsCommandResult<void, VisitMedicalImgaingCreateParameters> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VisitMedicalImagingCreateCommand();
         command.visitId = options.visitId;
         command.medicalInformationId = parameters.medicalInformationId;
         command.icd9Code = parameters.icd9Code;
         command.examinationDate = parameters.examinationDate;
         command.description = parameters.description;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VisitMedicalImagingQuery);
         },
      }
   );
};
